var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-list-card",class:{borderTop:_vm.borderTop,'border-bottom':_vm.hasBorderBottom}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }